import { render, staticRenderFns } from "./communityConfig.vue?vue&type=template&id=212d512a"
import script from "./communityConfig.vue?vue&type=script&lang=js"
export * from "./communityConfig.vue?vue&type=script&lang=js"
import style0 from "./communityConfig.vue?vue&type=style&index=0&id=212d512a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports